var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { TextElement } from "./TextElement";
import { toCssColorString } from "../util/ColorPreset";
import { useContact3DPlayerRecords } from "../../../game/contact3d/replicatedObjects/Contact3DPlayerRecords";
export const PlayerText = (props) => {
    var _a;
    const { playerId } = props, rest = __rest(props, ["playerId"]);
    const players = useContact3DPlayerRecords();
    const isLocalPlayer = (_a = players.record[playerId]) === null || _a === void 0 ? void 0 : _a.isLocalPlayer;
    const textColor = isLocalPlayer ? toCssColorString(0x000000) : toCssColorString(0xFFFFFF);
    return _jsx(TextElement, Object.assign({ color1: textColor }, rest));
};
//# sourceMappingURL=PlayerText.js.map